import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { AppThunk } from '../store'
import {
  postMicrosoftSync,
  postMicrosoftLink,
  postMicrosoftDisassociation,
} from '../../apis/setting'
import { setErrors } from '../common/errorsSlice'
import {
  MicrosoftSyncResponse,
  MicrosoftCallbackUrl,
} from '../../types/setting'

export interface MicrosoftSyncState extends MicrosoftSyncResponse {
  isSucceeded: boolean
}

const initialState: MicrosoftSyncState = {
  login_url: "",
  isSucceeded: false,
}

const microsoftSyncSlice = createSlice({
  name: 'microsoftSync',
  initialState,
  reducers: {
    postMicrosoftSyncSuccess: (state, action: PayloadAction<MicrosoftSyncResponse>) => {
      state.login_url = action.payload.login_url
      return state
    },
    postMicrosoftLinkSuccess: (state) => {
      state.isSucceeded = true
      return state
    },
    requestFailure: (state) => {
      state.isSucceeded = false
      return state
    },
  },
})

export const {
  postMicrosoftSyncSuccess,
  postMicrosoftLinkSuccess,
  requestFailure,
} = microsoftSyncSlice.actions

export const microsoftSyncReducer = microsoftSyncSlice.reducer

export const createMicrosoftSync = (
  callback: (microsoft: MicrosoftSyncState) => void,
): AppThunk => async (dispatch) => {
  postMicrosoftSync()
    .then((result) => {
      dispatch(postMicrosoftSyncSuccess(result))
      callback(result)
    })
    .catch((error) => {
      dispatch(requestFailure())
      dispatch(setErrors(error))
    })
}

export const createMicrosoftLink = (
  params: MicrosoftCallbackUrl,
  callback: (result: boolean) => void,
  errorCallback: () => void,
): AppThunk => async (dispatch) => {
  postMicrosoftLink(params)
    .then(() => {
      dispatch(postMicrosoftLinkSuccess())
      callback(true)
    })
    .catch((error) => {
      dispatch(requestFailure())
      dispatch(setErrors(error))
      errorCallback()
    })
}

export const deleteMicrosoftSync = (
  callback: (microsoft: MicrosoftSyncState) => void,
): AppThunk => async (dispatch) => {
  postMicrosoftDisassociation()
    .then((result) => {
      dispatch(postMicrosoftSyncSuccess(result))
      callback(result)
    })
    .catch((error) => {
      dispatch(requestFailure())
      dispatch(setErrors(error))
    })
}
